// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import { fontConfig } from "@vanmeter/XDL/constants";
import { xParserOptions } from "@vanmeter/XDL/Utilities/htmlParser";
import parse from "html-react-parser";
import React, { FC } from "react";

const enum fields {
    message = "message",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.message]: string;
    };
}

export interface CopyRightStyles {}

export const copyRightStyles: CopyRightStyles = {};

const styles = copyRightStyles;

type Props = OwnProps & WidgetProps;

const CopyRight: FC<Props> = ({ fields }) => {
    return (
        <Typography {...fontConfig.xSmallSingleLine} color="common.white">
            {parse(fields.message.replace("{x}", String(new Date().getFullYear())), xParserOptions)}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: CopyRight,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
        displayName: "Copy Right",
        fieldDefinitions: [
            {
                name: fields.message,
                editorTemplate: "RichTextField",
                displayName: "Message",
                defaultValue: "©{x} [Company Name].. All Rights Reserved.",
                isRequired: true,
                fieldType: "Translatable",
                tooltip: "Use {x} as a placeholder for the year in the message. i.e: ©{x}. All Rights Reserved.",
            },
        ],
    },
};

export default widgetModule;
